import { t as r } from "./to-string.js";
var t = function t(_t, n) {
  return void 0 === _t ? arguments.length < 2 ? "" : n : r(_t);
};
export { t as n };